export enum COBarChartViewProps {
  RES_WIDTH = '100%',
  XAXIS_DATAKEY = 'name',
  LABEL_VALUE = 'kgCO\u2082e',
  LABEL_VALUE2 = '%',
  LABEL_POSITION = 'insideLeft',
  BAR_DATAKEY = 'emission',
  BAR_FILL = '#005CA7',
  TEXT_ANCHOR = 'middle',
  TEXT_ANCHOR_FILL = '#000',
  LABEL_LIST_DATAKEY = 'emission',
  LABEL_LIST_POSITION = 'top',
  PRODUCT_LABEL_TOTAL = '% of total',
  PRODUCT_LABEL_STAGE = '% of stage',
}
